import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import debounce from 'debounce';

// Components
import AppointmentFlowWizard from 'components/templates/AppointmentFlowWizard/';
import AppointmentFlowHeader from 'components/molecules/AppointmentFlowHeader/';
import AppointmentFlowFooter from 'components/molecules/AppointmentFlowFooter/';
import ServicesList from 'components/molecules/ServicesList';
import ServiceTextBox from 'components/atoms/ServiceTextBox';
import InputField from 'components/atoms/InputField';
import { Container } from 'reactstrap';

// Utils
import { specialCharacters } from 'utils/string';
import { SERVICES_ROUTE, TRANSPORTATION_ROUTE } from 'constants/routes';
import { NAVIGATION } from 'constants/navigations';

import './IndividualServicesPage.scss';
import { resetScrollPosition } from 'utils/DOM';

const { FORWARD } = NAVIGATION;
const ns = 'individual-services-page';

class IndividualServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      term: '',
      searchResults: []
    };
  }

  componentWillMount() {
    resetScrollPosition(0);
  }

  servicesSearch(term) {
    const { individualServices } = this.props;
    const searchResults = individualServices.filter(service => {
      const searchRegex = new RegExp(specialCharacters(term), 'i');
      return searchRegex.test(service.name);
    });
    this.setState({ term, searchResults });
  }

  render() {
    const {
      servicesCount,
      className,
      mostCommonServices,
      gtmUserEventTellUsMoreSelected,
      allServices,
      goTo,
      intl
    } = this.props;
    const { term, searchResults } = this.state;
    const classProps = classNames(ns, className);
    const searchAddonConf = {
      isGlyhicon: true,
      addonValue: 'search'
    };
    const servicesSearch = debounce(
      searchTerm => this.servicesSearch(searchTerm),
      300
    );
    const inputConf = {
      onChange: ({ target: { value } }) => {
        servicesSearch(value);
      }
    };
    return (
      <AppointmentFlowWizard
        className={classProps}
        header={() => (
          <div>
            <AppointmentFlowHeader
              label={intl.formatMessage({ id: 'c8.header.services' })}
              routeTo={SERVICES_ROUTE}
              backButtonAriaLabel={intl.formatMessage({
                id: 'c8.aria.back.to.services',
                defaultMessage: 'Back to services'
              })}
            />
            <Container className="appointment-flow-wizard__header-search">
              <form action="#" onSubmit={e => e.preventDefault()}>
                <InputField
                  type={'search'}
                  placeholder={intl.formatMessage({
                    id: 'c8.individual.services.page.search'
                  })}
                  leftAddonConf={searchAddonConf}
                  className={'search-input'}
                  inputConf={inputConf}
                  inputAriaLabel={intl.formatMessage({
                    id: 'c8.aria.search.services',
                    defaultMessage: 'Search services'
                  })}
                  iconAriaHidden={true}
                />
              </form>
            </Container>
          </div>
        )}
        footer={() => (
          <AppointmentFlowFooter
            buttonDisabled={servicesCount < 1}
            buttonText={intl.formatMessage({ id: 'c8.footer.next' })}
            onClick={() => {
              gtmUserEventTellUsMoreSelected();
              goTo(TRANSPORTATION_ROUTE, FORWARD);
            }}
            ariaLabel={intl.formatMessage({
              id: 'c8.aria.continue.setting.up.your.appointment',
              defaultMessage: 'Continue setting up your appointment'
            })}
          />
        )}
        body={() => (
          <Container role={'list'}>
            <div
              hidden={term !== '' || mostCommonServices.length === 0}
              tabIndex={0}
              aria-label={intl.formatMessage({
                id: 'c8.aria.most.common.services',
                defaultMessage: 'Most Common Services'
              })}
            >
              <h1 className={`${ns}__label`}>
                {intl.formatMessage({
                  id: 'c8.individual.services.page.most.common.label'
                })}
              </h1>
              <ServicesList
                serviceList={mostCommonServices}
                group={'mostCommon'}
              />
            </div>
            <div
              hidden={term !== '' || allServices.length === 0}
              tabIndex={0}
              aria-label={intl.formatMessage({
                id: 'c8.aria.all.individual.services',
                defaultMessage: 'All Individual Services'
              })}
            >
              <h1 className={`${ns}__label`}>
                {intl.formatMessage({
                  id: 'c8.individual.services.page.all.result'
                })}
              </h1>
              <ServicesList serviceList={allServices} group={'all'} />
            </div>
            <div hidden={term === ''}>
              <h1 className={`${ns}__label`}>
                {intl.formatMessage({
                  id: 'c8.individual.services.page.search.result'
                })}
              </h1>
              <ServicesList
                serviceList={searchResults}
                group={'searchResults'}
              />
            </div>
            <ServiceTextBox />
          </Container>
        )}
      />
    );
  }
}

IndividualServices.propTypes = {
  addService: PropTypes.func.isRequired,
  allServices: PropTypes.array.isRequired,
  className: PropTypes.string,
  goTo: PropTypes.func.isRequired,
  gtmUserEventTellUsMoreSelected: PropTypes.func.isRequired,
  individualServices: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
  mostCommonServices: PropTypes.array.isRequired,
  promotion: PropTypes.object,
  removeService: PropTypes.func.isRequired,
  servicesCount: PropTypes.number.isRequired
};

export default IndividualServices;



// WEBPACK FOOTER //
// ./src/components/pages/IndividualServicesPage/IndividualServicesPage.js